module.exports = __webpack_public_path__ + "static/media/navidad15.1d0f1ec0.webp";